import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CurrencyFilterPipe } from '../private/crypto-wallet/currencies-filter/currency-filter-pipeline';
import { AccordionPanelComponent } from './accordion-panel/accordion-panel.component';
import { AccordionComponent } from './accordion/accordion.component';
import { AlertComponent } from './alert/alert.component';
import { ArrowComponent } from './arrow/arrow.component';
import { BackComponent } from './back/back.component';
import { BlockchainSelectComponent } from './blockchain-select/blockchain-select.component';
import { ChartComponent } from './chart/chart.component';
import { CopyComponent } from './copy/copy.component';
import { CryptoWalletNameComponent } from './crypto-wallet-name/crypto-wallet-name.component';
import { CurrencyListComponent } from './currency-list/currency-list.component';
import { CustomGasPrice } from './custom-gas-price/custom-gas-price.component';
import { DividerComponent } from './divider/divider.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { AddressCarryPipe } from './pipes/address-carry.pipe';
import { AddressShorterPipe } from './pipes/address-shortender.pipe';
import { BigNumberPipe } from './pipes/big-number.pipe';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { HideBalancePipe } from './pipes/hide-balance.pipe';
import { SafePipe } from './pipes/safe-pipe.pipe';
import { QrScannerComponent } from './qr-scanner/qr-scanner.component';
import { SearchBoxComponent } from './search-box/search-box.component';
import { ShareComponent } from './share/share.component';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs/tabs.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { TransactionConfirmationComponent } from './transaction-confirmation/transaction-confirmation.component';
import { TransactionFeeComponent } from './transaction-fee/transaction-fee.component';
import { UserVerificationComponent } from './user-verification/user-verification.component';
import { IconsModule } from '../icons/icons.module';
import { SignMessageComponent } from './sign-message/sign-message.component';
import { GuideComponent } from './guide/guide.component';

@NgModule({
    declarations: [
        BackComponent,
        ArrowComponent,
        ChartComponent,
        AddressShorterPipe,
        DividerComponent,
        CurrencyListComponent,
        CopyComponent,
        ShareComponent,
        TransactionFeeComponent,
        QrScannerComponent,
        ToggleSwitchComponent,
        SearchBoxComponent,
        CurrencyFilterPipe,
        CustomDatePipe,
        SafePipe,
        AlertComponent,
        LoadingSpinnerComponent,
        CustomGasPrice,
        BigNumberPipe,
        BlockchainSelectComponent,
        HideBalancePipe,
        TabsComponent,
        TabComponent,
        AccordionComponent,
        AccordionPanelComponent,
        CryptoWalletNameComponent,
        AddressCarryPipe,
        TransactionConfirmationComponent,
        UserVerificationComponent,
        SignMessageComponent,
        GuideComponent
    ],
    imports: [ CommonModule, TranslateModule, FormsModule, IconsModule ],
    exports: [
        TranslateModule,
        BackComponent,
        ReactiveFormsModule,
        ArrowComponent,
        ChartComponent,
        AddressShorterPipe,
        DividerComponent,
        CurrencyListComponent,
        CopyComponent,
        ShareComponent,
        TransactionFeeComponent,
        QrScannerComponent,
        ToggleSwitchComponent,
        SearchBoxComponent,
        CurrencyFilterPipe,
        CustomDatePipe,
        AlertComponent,
        LoadingSpinnerComponent,
        CustomGasPrice,
        BigNumberPipe,
        SafePipe,
        BlockchainSelectComponent,
        HideBalancePipe,
        TabsComponent,
        TabComponent,
        AccordionPanelComponent,
        AccordionComponent,
        CryptoWalletNameComponent,
        AddressCarryPipe,
        TransactionConfirmationComponent,
        UserVerificationComponent,
        IconsModule,
        SignMessageComponent,
        GuideComponent
    ],
})
export class SharedModule { }
